<script>
import * as d3 from 'd3'

import AreaChart from '@/components/plots/AreaChart'

export default {
  computed: {
    curve_type() {
      switch(this.step) {
        case 'before':
          return d3.curveStepBefore
        case 'after':
          return d3.curveStepAfter
        default:
          return d3.curveStep
      }
    }
  },
  extends: AreaChart,
  name: 'candela-area-chart-stepped',
  props: {
    step: {type: String, default: () => 'normal'}
  }
}
</script>
